import { useAppDispatch, useAppSelector } from '@/hooks';
import { useBetPlaceMutation, useGetStakesQuery } from '@/store/api/betApi';
import { clearBet, setBetRate, setStakeAmount } from '@/store/slices/betSlice';
import { PlaceBetPayload } from '@/types/Bet';
import { formatNumber, isGuestUser } from '@/utils';
import React, { useEffect, useState } from 'react';
import ComponentLoader from './common/ComponentLoader';

const Betslip = () => {
  const [betPlace, { isLoading: IsBetPlacing }] = useBetPlaceMutation();
   const { walletInfo } = useAppSelector((state) => state.user);
    const mainWallet = walletInfo?.find((item) => item?.type?.toLowerCase() == 'main');
const mainBalance = Number(
  (
    Number(mainWallet?.amount ?? 0) -
    Math.abs(Number(mainWallet?.exposureAmount ?? 0)) -
    Number(mainWallet?.lockedAmount ?? 0)
  ).toFixed(2)
);
  const [acceptOddsChange] = useState<boolean>(false);
  const isGuest = isGuestUser();
  const { data: stakeData } = useGetStakesQuery(undefined, { skip: isGuest });
  const { selectedBet } = useAppSelector((state) => state.bet);
  const betDetails = useAppSelector((state) => state.bet);
  const [stake, setStake] = useState(0);

  const dispatch = useAppDispatch();

  const addStake = (value: number) => {
    setStake((prev) => prev + value);
  };

  const reset = () => {
    dispatch(clearBet());
    setStake(0);
  };

  const setMinStake = () => {
    setStake(betDetails.selectedBet?.minBet || 0);
  };

  const setMaxStake = () => {
    setStake(betDetails.selectedBet?.maxBet || 0);
  };

  const setAllIn = () => {
    setStake(mainBalance || 0);
  };

  const handleBetPlace = async () => {
    if (!selectedBet) return;

    const {
      eventId,
      marketId,
      marketName,
      marketCategory,
      marketType,
      selectionId,
      runnerName,
      betOn,
      rate,
      fancyPercentage,
    } = selectedBet;

    if (!eventId || !marketId || !marketName || !selectionId || !runnerName || !rate || !betOn) {
      return;
    }

    const payload: PlaceBetPayload = {
      eventId,
      marketId,
      marketName,
      marketCategory: marketCategory!,
      marketType: marketType!,
      selectionId,
      runnerName,
      betOn: betOn,
      stake: stake,
      rate,
      fancyPercentage,
      acceptOddsChange,
    };

    try {
      await betPlace(payload).unwrap();
      dispatch(clearBet());
      setStake(0);
    } catch (error: unknown) {
      console.log(error);
    }
  };

  const increaseRate = () => {
    dispatch(setBetRate(Number((Number(betDetails.selectedBet?.rate ?? 0) + 0.01).toFixed(2))));
  };

  const decreaseRate = () => {
    dispatch(
      setBetRate(Number(Math.max(0, Number(betDetails.selectedBet?.rate ?? 0) - 0.01).toFixed(2)))
    );
  };
  const handleRateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!/^\d*\.?\d*$/.test(value)) return;

    dispatch(setBetRate(Number(value)));
  };

  useEffect(() => {
    dispatch(setStakeAmount(stake));
  }, [stake]);

  // useEffect(() => {
  //   dispatch(clearBet());
  // }, [location.pathname]);
  useEffect(() => {
    setStake(betDetails.stake);
  }, [selectedBet?.marketId, selectedBet?.selectionId, selectedBet?.betOn, betDetails.stake]);
  return (
    <div className="text-sm  overflow-y-auto">
      {selectedBet && (
        <div className={`${selectedBet?.betOn?.toLowerCase() === 'back' ? 'bg-back' : 'bg-lay'}`}>
          {/* Bet Slip Header */}
          <div
            className={`${selectedBet?.betOn?.toLowerCase() === 'back' ? 'bg-back-dark' : 'bg-lay-dark'} text-gray-800 px-3 py-1 font-bold flex justify-between items-center `}
          >
            <span>BET SLIP</span>
            <button onClick={reset} className="text-white text-xl font-bold hover:opacity-80">
              ✕
            </button>
          </div>

          {/* Match Info */}
          <div className=" text-gray-800 px-3 py-1 bg-opacity-90">
            <div className=" text-sm">
              {selectedBet?.eventName ? ` ${selectedBet.eventName}` : 'Match'}
            </div>
            <div className="font-semibold">{selectedBet?.runnerName}</div>
            <div className="flex justify-end gap-1 text-xs ">
              <span>MIN: {selectedBet?.minBet ||0}</span>
              <span>MAX: {selectedBet?.maxBet ? formatNumber(selectedBet.maxBet) : 0}</span>
            </div>
          </div>

          {/* Odds and Stake Section */}
          <div className=" bg-opacity-95 p-2">
            <div className="grid grid-cols-2 gap-1 items-center mb-1">
              {/* Odds Input */}
              <div className="flex items-center  gap-1">
                <button
                  onClick={decreaseRate}
                  className="bg-gray-700 text-white h-8 w-8 flex items-center justify-center font-bold hover:bg-gray-800"
                >
                  −
                </button>
                <input
                  value={selectedBet?.rate ? selectedBet?.rate : ''}
                  onChange={handleRateChange}
                  className="h-8 w-full text-center bg-white border-2 border-gray-400 font-bold"
                />
                <button
                  onClick={increaseRate}
                  className="bg-gray-700 text-white h-8 w-8 flex items-center justify-center font-bold hover:bg-gray-800"
                >
                  +
                </button>
              </div>

              {/* Stake Input */}
              <div className="flex-1">
                <input
                  type="text"
                  value={stake}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[0-9]*$/.test(value)) {
                      setStake(Number(value));
                    }
                  }}
                  inputMode="numeric"
                  placeholder="Stake: 100"
                  className="w-full h-8 text-center bg-gray-200 border-2 border-gray-300 font-semibold text-gray-600 placeholder-gray-500"
                />
              </div>
            </div>

            {/* Stake Quick Buttons Grid */}
            <div className="grid grid-cols-4 gap-0.5  mb-1">
              {stakeData?.stakeSet?.slice(0, 8).map(({ value, label }, index) => (
                <button
                  key={index}
                  onClick={() => addStake(value)}
                  className="bg-white  p-2 text-xs font-bold hover:bg-gray-100 text-gray-800"
                >
                  +{formatNumber(label)}
                </button>
              ))}
            </div>

            {/* MIN, MAX, ALL IN, CLEAR Buttons */}
            <div className="grid grid-cols-4 gap-0.5 mb-1">
              <button
                onClick={setMinStake}
                className="bg-yellow-400 text-white font-bold py-1 hover:bg-yellow-500"
              >
                MIN
              </button>
              <button
                onClick={setMaxStake}
                className="bg-blue-900 text-white font-bold py-1 hover:bg-blue-950"
              >
                MAX
              </button>
              <button
                onClick={setAllIn}
                className="bg-green-600 text-white font-bold py-1 hover:bg-green-700"
              >
                ALL IN
              </button>
              <button
                onClick={() => setStake(0)}
                className="bg-red-600 text-white font-bold py-1 hover:bg-red-700"
              >
                CLEAR
              </button>
            </div>

            {/* Accept odds change toggle */}
            {/* <div className="flex items-center px-2 py-2 border-t border-gray-200">
            <label className="flex items-center gap-2 text-sm select-none">
              <input
                type="checkbox"
                checked={acceptOddsChange}
                onChange={() => setAcceptOddsChange((s) => !s)}
                className="h-4 w-4"
              />
              <span>Accept odds change</span>
            </label>
          </div> */}

            {/* Bottom Action Buttons */}
            <div className="grid grid-cols-2 gap-2">
              <button
                onClick={reset}
                className="bg-red-400 text-white font-bold py-2 hover:bg-red-500 text-base"
              >
                CANCEL
              </button>
              <button
                onClick={handleBetPlace}
                className="bg-green-600 text-white font-bold py-2 hover:bg-green-700 text-base"
              >
                SUBMIT
              </button>
            </div>
            {IsBetPlacing && <ComponentLoader />}
          </div>
        </div>
      )}
    </div>
  );
};

export default Betslip;
